export default {
  boldList: [
    { label: '默认', value: 'initial' },
    { label: '加粗', value: 'bold' },
    { label: '100', value: '100' },
    { label: '200', value: '200' },
    { label: '300', value: '300' },
    { label: '400', value: '400' },
    { label: '500', value: '500' },
    { label: '600', value: '600' },
    { label: '700', value: '700' },
    { label: '800', value: '800' },
    { label: '900', value: '900' },
  ],
  alignList: [
    { label: '左对齐', value: 'left' },
    { label: '居中', value: 'center' },
    { label: '右对齐', value: 'right' },
  ],
  familyList: [
    { label: '黑体', value: '黑体' },
    { label: '宋体', value: '宋体' },
    { label: '雅黑', value: '雅黑' },
  ],
  fontSizeList: [
    { label: '12', value: '12' },
    { label: '14', value: '14' },
    { label: '16', value: '16' },
    { label: '18', value: '18' },
    { label: '20', value: '20' },
    { label: '22', value: '22' },
    { label: '24', value: '24' },
    { label: '26', value: '26' },
    { label: '28', value: '28' },
    { label: '30', value: '30' },
    { label: '32', value: '32' },
    { label: '34', value: '34' },
    { label: '36', value: '36' },
    { label: '38', value: '38' },
  ],
  lineHeightList: [
    { label: '26', value: '26' },
    { label: '28', value: '28' },
    { label: '30', value: '30' },
    { label: '32', value: '32' },
    { label: '34', value: '34' },
    { label: '36', value: '36' },
    { label: '38', value: '38' },
    { label: '40', value: '40' },
    { label: '42', value: '42' },
    { label: '44', value: '44' },
    { label: '46', value: '46' },
    { label: '48', value: '48' },
    { label: '50', value: '50' },
    { label: '52', value: '52' },
    { label: '54', value: '54' },
    { label: '56', value: '56' },
    { label: '58', value: '58' },
    { label: '60', value: '60' },
  ],
  islineList: [
    { label: '是', value: true },
    { label: '否', value: false },
  ],
}
